import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';
import { Result, Layout } from 'antd';
import messages from './messages';

const { Content } = Layout;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidUpdate(
    prevProps,
    prevState,
  ) {
    if (
      this.state.error
      && prevState.error !== null
      && prevProps.reset !== this.props.reset
    ) {
      this.setState({ error: null });
    }
  }

  componentDidCatch(error, errorInfo) {
    if (error.message === 'Unauthorized') {
      this.props.history.replace('/login', { referrer: this.props.location.pathname });
    } else {
      console.warn(error, errorInfo);
    }
  }

  static getDerivedStateFromError(error) {
    return { error: error.message !== 'Unauthorized' ? error : null };
  }

  render() {
    if (this.state.error) {
      return (
        <Content style={{ justifyContent: 'center', alignItems: 'center' }}>
          <Result
            status="error"
            title={<FormattedMessage {...messages.errorHeader} />}
            subTitle={<FormattedMessage {...messages.errorMessage} />}
          >
            {process.env.NODE_ENV !== 'production' && (
              <pre style={{ overflow: 'auto' }}>
                {this.state.error.stack}
              </pre>
            )}
          </Result>
        </Content>
      );
    }
    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
